import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumDateType implements BaseEnumType {
  private static allValues: EnumDateType[] = []; // make sure this is top-most
  
  public static despatch = new EnumDateType(1, "Despatch", "enum_date_type_despatch");
  public static delivery = new EnumDateType(2, "Delivery", "enum_date_type_delivery");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumDateType.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isDespatch() { return this === EnumDateType.despatch; }
  public isDelivery() { return this === EnumDateType.delivery; }

  public static getValues(): readonly EnumDateType[] {
    return EnumDateType.allValues;
  }

  public static getValuesExcept0(): readonly EnumDateType[] {
    return EnumDateType.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumDateType {
    const found = EnumDateType.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumDateType - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumDateType): EnumDateType {
    const found = name ? EnumDateType.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumDateType - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumDateType>): boolean {
    return this.key === other?.key;
  }
}